












































































































































import i18n from 'vue-i18n';
import axios from 'axios';
import { get } from 'lodash';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoEvent from '@/components/Molecules/co-event/CoEvent.vue';
import CoThumbnail from '@/components/Molecules/co-thumbnail/CoThumbnail.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoScrollMarker from '@/components/Molecules/co-scroll-marker/CoScrollMarker.vue';
import CoLink from '@/components/Atoms/co-link/CoLink.vue';
import CoRoundButton from '../../../../Atoms/co-round-button/CoRoundButton.vue';
import CoButton from '../../../../Atoms/co-button/CoButton.vue';
import CoIcon from '../../../../Atoms/co-icon/CoIcon.vue';

export default {
    i18n: {
        messages: {
            en: {
                endofeventlistreached: 'All events loaded',
                eventsemptyheadline: 'Community Events',
                eventsemptysubline: 'Create events on your community platform.',
                eventsemptycta: 'Create an event',
            },
            de: {
                endofeventlistreached: 'Alle Veranstaltungen geladen',
                eventsemptyheadline: 'Community-Veranstaltungen',
                eventsemptysubline:
                    'Erstelle Veranstaltungen, um Wissen auszutauschen und gemeinsame Erfahrungen zu teilen.',
                eventsemptycta: 'Erstelle eine Veranstaltung',
            },
        },
    },
    name: 'ListEvents',
    components: {
        CoButton,
        CoIcon,
        CoRoundButton,
        CoCard,
        CoHeadline,
        CoEvent,
        CoThumbnail,
        CoText,
        CoScrollMarker,
        CoLink,
    },
    props: {
        variant: {
            type: String,
            default: 'default',
            validator: (value) => ['default', 'micro', 'list', 'full'].includes(value),
        },
    },
    data() {
        return {
            feed: [],
            feedNextPage: null,
            loading: true,
            thisSpaceID: this.$store?.state?.space?.ID || null,

            past: [],
            nextPageOfPastEvents: null,
            loadingPastEvents: false,
        };
    },
    computed: {
        me() {
            return this.$store?.state.me || {};
        },
        isDesktop() {
            return window.innerWidth >= 768;
        },
        isAdmin() {
            if (
                this.$store?.state?.me?.Permissions &&
                this.$store.state.me.Permissions.includes('space_admin') === true
            ) {
                return true;
            }
            return false;
        },
        // EventsOff only blocks creation entry points; existing event lists can still render.
        isEventsEnabled() {
            return !this.$store?.state?.space?.EventsOff;
        },
        isUserAllowedToCreateEvent() {
            return this.$store.state.permissions && this.$store.state.permissions['events.create'] === true;
        },
        isUserLogggedIn() {
            return this.me.ID ? true : false;
        },
    },
    async mounted() {
        this.loading = true;
        // fetch events
        await this.getEvents();
        await this.getPastEvents();
    },
    methods: {
        get,
        getEvents() {
            this.loading = true;
            return axios
                .post('/event/list/circles/v2', {
                    From: Math.round(Date.now() / 1000),
                    To: Math.round(Date.now() / 1000) * 2,
                    Limit: 10,
                    Params: this.feedNextPage?.length ? this.feedNextPage : null,
                })
                .then(async (response) => {
                    const events = response.data?.Objects || null;
                    this.feedNextPage = response.data?.NextParams || null;

                    if (events?.length < 1) return;

                    //map user profiles to events and add to feed
                    let feedPage = [];
                    events.forEach((e) => {
                        if (!e.object || typeof e.object !== 'object') return;
                        let eventItem = e.object;
                        let amIattending = eventItem.Participants?.includes(this.me.ID) || false;
                        // // add organizers to participants list and map user profiles
                        e.object.Organizers = e.object.OrganizersProfiles || [];
                        // // aggregate participants and organizers profiles as one participants list
                        e.object.Participants = (e.object.ParticipantProfiles || []).concat(e.object.Organizers);
                        //add item to the feedPage
                        feedPage.push({
                            ...eventItem,
                            Images: eventItem.ImageURL ? [{ ImageURL: eventItem.ImageURL }] : null,
                            Attend: amIattending,
                        });
                    });
                    //update the feed list
                    this.feed = this.feed.concat(feedPage);
                })
                .catch((error) => {
                    this.feedNextPage = null;
                    // todo show error
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        loadNextPage({ entry, observer }) {
            if (this.feedNextPage && !this.loading) {
                this.getEvents();
            }
        },

        getPastEvents() {
            this.loadingPastEvents = true;
            const url = this.nextPageOfPastEvents || '/event/list/past';
            return axios
                .get(url)
                .then(async (response) => {
                    const events = response.data?.objects || null;
                    this.nextPageOfPastEvents = response.data?.next || null;

                    if (events?.length < 1) return;

                    // map user profiles to events and add to feed
                    let feedPage = [];
                    events.forEach((e) => {
                        if (!e.object || typeof e.object !== 'object') return;
                        const eventItem = e.object;
                        const amIattending = eventItem.Participants?.includes(this.me.ID) || false;
                        // // add organizers to participants list and map user profiles
                        e.object.Organizers = e.object.OrganizersProfiles || [];
                        // // aggregate participants and organizers profiles as one participants list
                        e.object.Participants = (e.object.ParticipantProfiles || []).concat(e.object.Organizers);
                        // add item to the feedPage
                        feedPage.push({
                            ...eventItem,
                            Images: eventItem.ImageURL ? [{ ImageURL: eventItem.ImageURL }] : null,
                            Attend: amIattending,
                        });
                    });
                    // add to the past events list the newly fetched events
                    this.past = this.past.concat(feedPage);
                })
                .catch((error) => {
                    this.nextPageOfPastEvents = null;
                    // todo show error
                })
                .finally(() => {
                    this.loadingPastEvents = false;
                });
        },
        scrollToTop() {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        },
    },
};
